import { render, staticRenderFns } from "./CampaignEdition.vue?vue&type=template&id=872d7664&"
import script from "./CampaignEdition.vue?vue&type=script&lang=js&"
export * from "./CampaignEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports